import oneC_ITS from 'assets/icons/oneC_ITS.png';

export const title = 'Сервисы 1С:ИТС';
export const description =
  'Сервисы 1С:ИТС — это возможности программ 1С, экономящие время в учёте и работе с госистемами, сокращающие ошибки и дающие информацию для задач. Рекомендуется приобретать в составе тарифов 1С:ИТС';
export const btnText = 'Скачать прайс';
export const icon = oneC_ITS;

const LABELS_TEXTS = {
  buhgalteriya: 'Для бухгалтерии',
  edo: 'ЭДО',
  business: 'Для бизнеса',
  retail: 'Для розницы',
  support: 'Поддержка',
  internet: '1С через Интернет',
};

export const labels = [
  LABELS_TEXTS.buhgalteriya,
  LABELS_TEXTS.edo,
  LABELS_TEXTS.business,
  LABELS_TEXTS.retail,
  LABELS_TEXTS.support,
  LABELS_TEXTS.internet,
];

const commonServices = {
  '1С:Контрагент': {
    title: '1С:Контрагент',
    description:
      'Автоматическое заполнение реквизитов контрагентов в различных документах и быстрая проверка информации о контрагентах',
    link: 'https://v8.1c.ru/its/services/1c-kontragent/',
  },
  '1С:Кабинет сотрудника': {
    title: '1С:Кабинет сотрудника',
    description: 'Мобильное взаимодействие сотрудников и бухгалтерии по кадровым вопросам',
    link: 'https://v8.1c.ru/its/services/1s-kabinet-sotrudnika/',
  },
  '1С-ЭДО': {
    title: '1С-ЭДО',
    description:
      'Обмен счетами-фактурами и другими юридически значимыми документами с поставщиками, покупателями и прочими контрагентами в электронной форме из программ 1С',
    link: 'https://v8.1c.ru/its/services/1c-edo/',
  },
  '1С:Предприятие через Интернет (1С:Фреш)': {
    title: '1С:Предприятие через Интернет (1С:Фреш)',
    description: '1С:Фреш — сервис для работы с популярными программами 1С через интернет',
    link: 'https://v8.1c.ru/its/services/1c-predpriyatie-cherez-internet/',
  },
  '1С:Подпись': {
    title: '1С:Подпись',
    description:
      'Электронная подпись для обмена юридически значимыми электронными документами, отправки регламентированной отчётности в контролирующие органы и работы с государственными информационными системами',
    link: 'https://v8.1c.ru/its/services/1c-podpis/',
  },
  '1С-Такском': {
    title: '1С-Такском',
    description:
      'Обмен счетами-фактурами и другими юридически значимыми документами с поставщиками, покупателями и прочими контрагентами в электронной форме из программ 1С',
    link: 'https://v8.1c.ru/its/services/1c-takskom/',
  },
  '1СПАРК Риски': {
    title: '1СПАРК Риски',
    description:
      'Оценка надёжности и мониторинг контрагентов в программах 1С для принятия взвешенных решений о сотрудничестве и минимизации налоговых рисков',
    link: 'https://v8.1c.ru/its/services/1spark-riski/',
  },
  '1С:МДЛП': {
    title: '1С:МДЛП',
    description:
      'Подключение к системе маркировки Честный ЗНАК и передача данных о движении лекарственных препаратов в ФГИС МДЛП',
    link: 'https://v8.1c.ru/its/services/1s-mdlp/',
  },
  'Отвечает аудитор': {
    title: 'Отвечает аудитор',
    description:
      'Персональные письменные консультации от экспертов, аудиторов и методистов «1С» по вопросам бухгалтерского, налогового и кадрового учёта',
    link: 'https://v8.1c.ru/its/services/otvechaet-auditor/',
  },
  'Информационная система 1С:ИТС': {
    title: 'Информационная система 1С:ИТС',
    description:
      'Справочники, консультации по законодательству, методики и инструкции по работе с программами «1С:Предприятия» (its.1c.ru)',
    link: 'https://v8.1c.ru/its/services/informatsionnaya-sistema-1c-its/',
  },
  '1С:ЕГИСЗ': {
    title: '1С:ЕГИСЗ',
    description:
      'Подключение к сервисам ЕГИСЗ организаций, оказывающих медицинскую помощь, для выполнения лицензионных требований',
    link: 'https://v8.1c.ru/its/services/1s-egisz/',
  },
  '1С-Чеки ОФД': {
    title: '1С-Чеки ОФД',
    description: 'Автоматическая загрузка фискальных данных в программы 1С напрямую из ОФД',
    link: 'https://v8.1c.ru/its/services/1s-cheki-ofd/',
  },
  '1С:Маркировка': {
    title: '1С:Маркировка',
    description: 'Комплексные решения для маркировки от фирмы «1С» и сертифицированных партнёров',
    link: 'https://v8.1c.ru/its/services/1s-markirovka/',
  },
  '1С-ЭПД': {
    title: '1С-ЭПД',
    description:
      'Обмен транспортными накладными и другими перевозочными документами в электронном виде',
    link: 'https://v8.1c.ru/its/services/1s-epd/',
  },
  '1С:Лекторий': {
    title: '1С:Лекторий',
    description:
      'Семинары по законодательству и его отражению в программах «1С:Предприятия» — в формате онлайн-трансляций и видеозаписей',
    link: 'https://v8.1c.ru/its/services/1c-lektoriy/',
  },
  '1С-Облачная касса': {
    title: '1С-Облачная касса',
    description: 'Приём платежей в программе 1С без приобретения обычной онлайн-кассы',
    link: 'https://v8.1c.ru/its/services/1s-oblachnaya-kassa/',
  },
  'ЭДО без электронной подписи для участников 1С:Бизнес-сеть': {
    title: 'ЭДО без электронной подписи для участников 1С:Бизнес-сеть',
    description:
      'Обмен электронными документами без электронной подписи между пользователями программ 1С',
    link: 'https://v8.1c.ru/its/services/edo-bez-elektronnoy-podpisi-dlya-uchastnikov-1s-biznes-set/',
  },
  '1С-ЭТП': {
    title: '1С-ЭТП',
    description:
      'Электронные подписи для участия в электронных торгах и работы на государственных порталах',
    link: 'https://v8.1c.ru/its/services/1c-etp/',
  },
  'Модуль 1C:EDI': {
    title: 'Модуль 1C:EDI',
    description:
      'EDI-обмен с торговыми партнёрами, автоматизация цепочек заказов и поставок продукции',
    link: 'https://v8.1c.ru/its/services/modul-1c-edi/',
  },
  '1С-Администратор': {
    title: '1С-Администратор',
    description:
      'Доступ к каталогу отчётов и обработок сообщества Инфостарт для эффективной работы IT-специалистов',
    link: 'https://v8.1c.ru/its/services/1s-administrator/',
  },
  mag1c: {
    title: 'mag1c',
    description:
      'Автоматическое создание веб-витрины бизнеса из программы 1С для приёма заказов или старта продаж через интернет',
    link: 'https://v8.1c.ru/its/services/mag1c/',
  },
  '1С:Номенклатура': {
    title: '1С:Номенклатура',
    description: 'Единый каталог описаний товаров в «1С:Предприятии 8»',
    link: 'https://v8.1c.ru/its/services/1c-nomenklatura/',
  },
  '1С:Бизнес-сеть. Торговая площадка': {
    title: '1С:Бизнес-сеть. Торговая площадка',
    description:
      'Торговая площадка в программах «1С:Предприятие» для поставщиков и покупателей (закупщиков)',
    link: 'https://v8.1c.ru/its/services/1c-biznes-set-torgovaya-ploshchadka/',
  },
  '1С:Универсальное прогнозирование': {
    title: '1С:Универсальное прогнозирование',
    description: 'Прогноз показателей бизнеса в программах «1С»',
    link: 'https://v8.1c.ru/its/services/1s-universalnoe-prognozirovanie/',
  },
  '1С:Прогнозирование продаж': {
    title: '1С:Прогнозирование продаж',
    description: 'Прогноз продаж для производственных и торговых компаний в программах «1С»',
    link: 'https://v8.1c.ru/its/services/1s-prognozirovanie-prodazh/',
  },
  '1С:СБП B2B': {
    title: '1С:СБП B2B',
    description: 'Моментальные платежи от юридических лиц',
    link: 'https://v8.1c.ru/its/services/1s-sbp-b2b/',
  },
  '1С:СБП C2B': {
    title: '1С:СБП C2B',
    description:
      'Способ принимать безналичную оплату от покупателей без пластиковых карт и эквайринга',
    link: 'https://v8.1c.ru/its/services/sistema-bystrykh-platezhey/',
  },
  '1С:Онлайн-заказы': {
    title: '1С:Онлайн-заказы',
    description:
      'Создание страницы с заказом и передача покупателю ссылки на него для ознакомления, проверки и оплаты',
    link: 'https://v8.1c.ru/its/services/1s-onlayn-zakazy/',
  },
  '1С:Бизнес-обучение': {
    title: '1С:Бизнес-обучение',
    description: 'Онлайн-обучение для генеральных директоров и других топ-менеджеров',
    link: 'https://v8.1c.ru/its/services/1s-biznes-obuchenie/',
  },
  '1С-Курьерика': {
    title: '1С-Курьерика',
    description: 'Управление собственной службой доставки',
    link: 'https://v8.1c.ru/its/services/1s-kurerika/',
  },
  '1С:Изменение сведений': {
    title: '1С:Изменение сведений',
    description:
      'Подготовка и отправка в ФНС пакета документов для внесения изменений в ЕГРЮЛ/ЕГРИП',
    link: 'https://v8.1c.ru/its/services/1s-izmenenie-svedeniy/',
  },
  '1С:Кредит': {
    title: '1С:Кредит',
    description:
      'Поиск кредитных предложений в программах 1С и автоматическое формирование заявки и пакета документов',
    link: 'https://v8.1c.ru/its/services/1s-kredit/',
  },
  smartway: {
    title: 'Smartway',
    description:
      'Организация командировок и автоматическое создание бухгалтерских и кадровых документов в программах 1С',
    link: 'https://v8.1c.ru/its/services/smartway/',
  },
  '1С:Курьер': {
    title: '1С:Курьер',
    description: 'Оформление курьерской доставки по городу из программ 1С',
    link: 'https://v8.1c.ru/its/services/1s-kurer/',
  },
};

export const cardsData = {
  // Для бухгалтерии
  [LABELS_TEXTS.buhgalteriya]: [
    commonServices['1С:Кабинет сотрудника'],
    commonServices['1С:Контрагент'],
    commonServices['1СПАРК Риски'],
    {
      title: '1С-Отчетность',
      description:
        'Подготовка и сдача регламентированной отчётности из программ «1С» во все контролирующие органы: ФНС, СФР, Росстат, Росалкогольтабакконтроль, Росприроднадзор, ФТС и банк России',
      link: 'https://v8.1c.ru/its/services/1c-otchetnost/',
    },
    commonServices['1С-ЭДО'],
    {
      title: '1С:Распознавание первичных документов',
      description: 'Автоматическое распознавание и создание первичных документов в программе 1С',
      link: 'https://v8.1c.ru/its/services/1s-raspoznavanie-pervichnykh-dokumentov/',
    },
    commonServices['Информационная система 1С:ИТС'],
    {
      title: '1С:Сверка 2.0',
      description: 'Автоматическая сверка документов с контрагентами',
      link: 'https://v8.1c.ru/its/services/1c-sverka/',
    },
    {
      title: '1С:ДиректБанк',
      description:
        'Отправка платежей и получение выписок прямо из программ 1С, без переключения в «Клиент-банк»',
      link: 'https://v8.1c.ru/its/services/1c-direktbank/',
    },
    commonServices['1С:Лекторий'],
    commonServices['Отвечает аудитор'],
    commonServices['1С:МДЛП'],
    commonServices['1С:Предприятие через Интернет (1С:Фреш)'],
    commonServices['1С:Подпись'],
    {
      title: '1С:Сканер чеков',
      description: 'Автоматическое заполнение авансовых отчётов данными из кассовых чеков',
      link: 'https://v8.1c.ru/its/services/1s-skaner-chekov/',
    },
    commonServices['1С-Такском'],
    {
      title: '1С-Финконтроль',
      description:
        'Внутренний контроль и автоматическая проверка правильности ведения учёта в бюджетных и автономных учреждениях',
      link: 'https://v8.1c.ru/its/services/1c-finkontrol/',
    },
    commonServices['1С:ЕГИСЗ'],
    commonServices['1С-Облачная касса'],
    commonServices['1С-Чеки ОФД'],
    commonServices['1С:Маркировка'],
    commonServices['1С-ЭПД'],
    commonServices['1С:Изменение сведений'],
    {
      title: '1С:ФинОтчетность',
      description: 'Подготовка и отправка в банк финансовой отчётности заёмщика',
      link: 'https://v8.1c.ru/its/services/1s-finotchetnost/',
    },
    commonServices.smartway,
  ],

  // ЭДО
  [LABELS_TEXTS.edo]: [
    commonServices['1С:Кабинет сотрудника'],
    commonServices['1С-ЭДО'],
    commonServices['Информационная система 1С:ИТС'],
    commonServices['1С:МДЛП'],
    commonServices['1С:Предприятие через Интернет (1С:Фреш)'],
    commonServices['1С:Подпись'],
    commonServices['1С-Такском'],
    commonServices['ЭДО без электронной подписи для участников 1С:Бизнес-сеть'],
    commonServices['1С-ЭТП'],
    commonServices['1С:ЕГИСЗ'],
    commonServices['1С:Маркировка'],
    commonServices['1С-ЭПД'],
    commonServices['Модуль 1C:EDI'],
  ],

  // Для бизнеса
  [LABELS_TEXTS.business]: [
    commonServices['1С:Контрагент'],
    commonServices['1СПАРК Риски'],
    commonServices['1С-ЭДО'],
    commonServices['Информационная система 1С:ИТС'],
    commonServices.mag1c,
    commonServices['1С:Номенклатура'],
    commonServices['1С:Бизнес-сеть. Торговая площадка'],
    commonServices['1С:МДЛП'],
    commonServices['1С:Предприятие через Интернет (1С:Фреш)'],
    commonServices['1С:Подпись'],
    commonServices['1С-Такском'],
    commonServices['ЭДО без электронной подписи для участников 1С:Бизнес-сеть'],
    commonServices['1С-ЭТП'],
    {
      title: '1C-UMI',
      description:
        'Готовые сайты для всех типов бизнеса: для специалистов, компаний, а также лендинги и интернет-магазины',
      link: 'https://v8.1c.ru/its/services/1c-umi/',
    },
    commonServices['1С:Универсальное прогнозирование'],
    commonServices['1С:Прогнозирование продаж'],
    {
      title: '1С:Синтез речи',
      description:
        'Облачное преобразование текста в речь человека, голосовые интерфейсы в программах «1С»',
      link: 'https://v8.1c.ru/its/services/1s-sintez-rechi/',
    },
    {
      title: '1С:Распознавание речи',
      description:
        'Облачное преобразование в текст потокового аудио или файлов с записью речи, голосовое управление программами 1С',
      link: 'https://v8.1c.ru/its/services/1s-raspoznavanie-rechi/',
    },
    commonServices['1С:СБП B2B'],
    commonServices['1С:СБП C2B'],
    commonServices['1С-Администратор'],
    commonServices['1С:ЕГИСЗ'],
    commonServices['1С:Онлайн-заказы'],
    commonServices['1С-Облачная касса'],
    commonServices['1С:Бизнес-обучение'],
    commonServices['1С-Курьерика'],
    {
      title: 'Bidzaar',
      description: 'Электронная торговая площадка для коммерческих закупок',
      link: 'https://v8.1c.ru/its/services/bidzaar/',
    },
    commonServices['1С:Маркировка'],
    commonServices['1С-ЭПД'],
    commonServices['1С:Изменение сведений'],
    {
      title: 'ЮKassa',
      description:
        'Приём платежей через сервис ЮKassa в программах 1С: выставление счётов и получения уведомлений об оплатах',
      link: 'https://v8.1c.ru/its/services/yukassa/',
    },
    {
      title: '1С:Лизинг',
      description:
        'Поиск предложений от лизинговых компаний в программах 1С и автоматическое формирование заявки и пакета документов',
      link: 'https://v8.1c.ru/its/services/1s-lizing/',
    },
    commonServices['1С:Кредит'],
    commonServices.smartway,
    commonServices['Модуль 1C:EDI'],
    commonServices['1С:Курьер'],
    {
      title: '1С:Доставка',
      description: 'Оформление доставки грузов по России и за границу из программ 1С',
      link: 'https://v8.1c.ru/its/services/1s-dostavka/',
    },
  ],

  // Для розницы
  [LABELS_TEXTS.retail]: [
    commonServices['1СПАРК Риски'],
    commonServices['1С-ЭДО'],
    commonServices['Информационная система 1С:ИТС'],
    {
      title: '1C-Ритейл Чекер',
      description:
        'Рекомендации по управлению ассортиментом розничного магазина на основе статистики продаж и прогноза спроса',
      link: 'https://v8.1c.ru/its/services/1c-riteyl-cheker/',
    },
    commonServices.mag1c,
    {
      title: '1С-Товары',
      description:
        'Прогноз спроса, автоматический заказ и управление ассортиментом розничного магазина',
      link: 'https://v8.1c.ru/its/services/1c-tovary/',
    },
    commonServices['1С:Номенклатура'],
    commonServices['1С:Бизнес-сеть. Торговая площадка'],
    {
      title: '1С-ОФД',
      description:
        'Подключение к операторам фискальных данных (ОФД) в соответствии с законом 54-ФЗ, онлайн-передача фискальных данных в ФНС и ЦРПТ (маркировка товаров)',
      link: 'https://v8.1c.ru/its/services/1c-ofd/',
    },
    commonServices['1С:Предприятие через Интернет (1С:Фреш)'],
    commonServices['1С:Подпись'],
    commonServices['1С-Такском'],
    commonServices['1С-ЭТП'],
    commonServices['1С:Универсальное прогнозирование'],
    commonServices['1С:Прогнозирование продаж'],
    commonServices['1С:СБП B2B'],
    commonServices['1С:СБП C2B'],
    commonServices['1С:Онлайн-заказы'],
    commonServices['1С-Облачная касса'],
    commonServices['1С-Чеки ОФД'],
    commonServices['1С:Бизнес-обучение'],
    commonServices['1С-Курьерика'],
    commonServices['1С:Маркировка'],
    {
      title: '1С:Касса облачное приложение',
      description: 'Простая автоматизация магазинов или точек оказания услуг',
      link: 'https://v8.1c.ru/its/services/1s-kassa-oblachnoe-prilozhenie/',
    },
    commonServices['1С-ЭПД'],
    commonServices['1С:Кредит'],
    commonServices['Модуль 1C:EDI'],
    commonServices['1С:Курьер'],
  ],

  // Поддержка
  [LABELS_TEXTS.support]: [
    commonServices['Информационная система 1С:ИТС'],
    {
      title: '1С:Облачный архив',
      description: 'Автоматическое резервное копирование информационных баз в облачное хранилище',
      link: 'https://v8.1c.ru/its/services/1c-oblachnyy-arkhiv/',
    },
    commonServices['1С:Лекторий'],
    commonServices['Отвечает аудитор'],
    {
      title: '1С-Коннект',
      description: 'Корпоративный чат и оперативная поддержка пользователей программ 1С',
      link: 'https://v8.1c.ru/its/services/1c-konnekt/',
    },
    {
      title: '1C-Store',
      description: 'Доступ к каталогу проверенных отчётов и обработок из локальных программ «1С»',
      link: 'https://v8.1c.ru/its/services/1c-store/',
    },
    commonServices['1С-Администратор'],
  ],

  // 1С через Интернет
  [LABELS_TEXTS.internet]: [
    {
      title: '1С:Линк',
      description:
        'Безопасный удалённый доступ через Интернет к программам 1С, установленным на вашем компьютере',
      link: 'https://v8.1c.ru/its/services/1c-link/',
    },
    commonServices['1С:Предприятие через Интернет (1С:Фреш)'],
  ],
};
